var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"medical-detail-pdf"},[(_vm.pet)?_c('div',[_c('MedicalDetailPDF',{attrs:{"med":_vm.med,"pet":_vm.pet.pet,"hospital":_vm.hospitalInfo,"hn":_vm.hn}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }